/* ZSportsTech — engraving.js
   Personalised engraving on the bat PDPs. Markup from snippets/engraving-field.liquid,
   which only emits it when the product has a truthy zbat.engravable metafield — so this
   file is a no-op on every other page.

   Shape: a one-line trigger in the buy box opens a modal holding the actual field. The
   committed value lives here, NOT in the input, because the input is inside a modal that
   is usually closed — reading the DOM at add-to-cart time would miss it. Cancel therefore
   discards edits and Save commits them, which is what the buttons imply.

   Public API: window.SCEngraving.properties() -> {} | { Engraving: "R. SHARMA 45" }
   Each PDP's add-to-cart merges that into the /cart/add.js payload.
   ─────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  /* Engraving is cut from a fixed character set. Anything outside it either has no
     glyph on the machine or reads as noise on a bat spine, so it is stripped on input
     rather than rejected at submit — the customer sees exactly what will be engraved. */
  var ALLOWED = /[^A-Z0-9 .&'\-]/g;

  var committed = '';          /* what will actually be engraved */
  var lastFocus = null;        /* restore focus here when the modal closes */

  function $(sel) { return document.querySelector(sel); }
  function box()      { return $('[data-engrave]'); }
  function modal()    { return $('[data-engrave-modal]'); }
  function overlay()  { return $('[data-engrave-overlay]'); }
  function input()    { return $('[data-engrave-input]'); }

  function normalise(raw) {
    return String(raw || '')
      .toUpperCase()
      .replace(ALLOWED, '')
      .replace(/\s+/g, ' ')
      .replace(/^\s+/, '');
  }

  /* ── Public API ────────────────────────────────────────────────────── */

  function value() { return committed; }

  /* Shopify line item properties for the committed value. Empty object when blank, so a
     skipped engraving leaves the line item exactly as it was before this feature — no
     stray "Engraving: " row in the cart, the email, or the packing slip, and two
     un-engraved bats still merge into one line at qty 2. */
  function properties() {
    return committed ? { Engraving: committed } : {};
  }

  /* Merge engraving onto a caller's own properties without clobbering them. */
  function withEngraving(props) {
    var out = {}, k;
    for (k in (props || {})) if (Object.prototype.hasOwnProperty.call(props, k)) out[k] = props[k];
    var eng = properties();
    for (k in eng) out[k] = eng[k];
    return out;
  }

  function clear() { committed = ''; syncTrigger(); }

  /* ── Trigger row ───────────────────────────────────────────────────── */

  function syncTrigger() {
    var root = box();
    if (!root) return;
    var empty = root.querySelector('[data-engrave-empty]');
    var set = root.querySelector('[data-engrave-set]');
    var preview = root.querySelector('[data-engrave-preview]');
    if (!empty || !set) return;
    if (committed) {
      if (preview) preview.textContent = committed;
      empty.hidden = true;
      set.hidden = false;
    } else {
      empty.hidden = false;
      set.hidden = true;
    }
  }

  /* ── Modal ─────────────────────────────────────────────────────────── */

  function syncCount() {
    var el = input();
    var counter = $('[data-engrave-count]');
    if (!el) return;
    var start = el.selectionStart;
    var before = el.value;
    var after = normalise(before);
    if (after !== before) {
      el.value = after;
      /* Keep the caret where the customer left it, minus whatever the filter removed —
         otherwise typing a stripped character jumps the cursor to the end mid-word. */
      var pos = Math.max(0, start - (before.length - after.length));
      try { el.setSelectionRange(pos, pos); } catch (e) {}
    }
    if (counter) counter.textContent = String(el.value.length);
  }

  function open() {
    var m = modal(), o = overlay(), el = input();
    if (!m) return;
    lastFocus = document.activeElement;
    /* Seed the field from the committed value, so re-opening shows what is currently set
       and Cancel can meaningfully discard whatever gets typed next. */
    if (el) el.value = committed;
    syncCount();
    m.hidden = false; if (o) o.hidden = false;
    requestAnimationFrame(function () {
      m.classList.add('is-open'); if (o) o.classList.add('is-open');
      if (el) { el.focus(); try { el.setSelectionRange(el.value.length, el.value.length); } catch (e) {} }
    });
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    var m = modal(), o = overlay();
    if (!m) return;
    m.classList.remove('is-open'); if (o) o.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () { m.hidden = true; if (o) o.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function save() {
    var el = input();
    committed = el ? normalise(el.value).trim() : '';
    syncTrigger();
    close();
  }

  window.SCEngraving = {
    value: value,
    properties: properties,
    withEngraving: withEngraving,
    clear: clear,
    open: open
  };

  function init() {
    if (!box()) return;

    /* Relocate the modal + overlay to <body>. The PDP buy column carries a CSS animation
       whose transform creates a containing block, which would otherwise scope
       position:fixed to that column and trap the modal inside it on mobile. */
    var m = modal(), o = overlay();
    if (o && o.parentNode !== document.body) document.body.appendChild(o);
    if (m && m.parentNode !== document.body) document.body.appendChild(m);

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-engrave-open]'))  { e.preventDefault(); open(); return; }
      if (e.target.closest('[data-engrave-close]')) { e.preventDefault(); close(); return; }
      if (e.target.closest('[data-engrave-save]'))  { e.preventDefault(); save(); return; }
      if (e.target.closest('[data-engrave-clear]')) { e.preventDefault(); clear(); return; }
      if (e.target.closest('[data-engrave-overlay]')) { close(); }
    });

    document.addEventListener('keydown', function (e) {
      var m = modal();
      if (!m || m.hidden) return;
      if (e.key === 'Escape') { e.stopPropagation(); close(); return; }
      /* Enter inside the field commits — the modal has no <form> to do it for us. */
      if (e.key === 'Enter' && e.target.closest('[data-engrave-input]')) { e.preventDefault(); save(); }
    });

    var el = input();
    if (el) {
      el.addEventListener('input', syncCount);
      /* Paste lands before the value updates, so re-read on the next tick. */
      el.addEventListener('paste', function () { window.setTimeout(syncCount, 0); });
    }

    syncTrigger();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
